import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./style.css";
import Table from "../TableItems/table";
import { PrivilegeContext } from "../../../context/PrivilegesContext";
import { DomainContext } from "../../../context/DomainContext";
import { TableSkeleton } from "../TableItems/table/skeleton";
import { useGenerateSearchFields } from "./Hooks/useGenerateSearchFields";
import { useGetTableData } from "./Hooks/useGetTableData";
import { useTranslation } from "react-i18next";

const ReportContent = ({ children, tableAPI ,needCheckbox, columns, handleSelected, FillData, stickyActions }) => {


  

  const [tableFiller, setTableFiller] = useState({ pageSize: 25, page: 0 });

  const { hiddenColumnsList } = useGenerateSearchFields(columns)

  const { dataLoading } = useContext(DomainContext);

  const { t, i18n } = useTranslation();

  const { data, totalRows } = useGetTableData(tableAPI, tableFiller ,FillData)

  const { privileges } = useContext(PrivilegeContext);

  const localizedColumns = useMemo(() => columns.map((column) => ({ ...column, Header: typeof column?.Header === 'function' ? column?.Header(t) : column?.Header })), [columns, i18n.language])

  return (
    <div className="pages-wrapper">

      {/*  <ReportTitle /> */}
      {children}
      {/**/}
      <Table
        needCheckbox={needCheckbox}
        isLoading={dataLoading}
        handleSelected={handleSelected}
        columns={localizedColumns}
        data={data||FillData}
        isNeedFetch={false}
        setTableFiller={setTableFiller}
        tableFiller={tableFiller}
        TotalRows={totalRows}
        hiddenColumns={hiddenColumnsList}
        hideActions={!privileges?.canDelete && !privileges?.canEdit}
        stickyActions={stickyActions}
      />

      <TableSkeleton isLoading={dataLoading} />

    </div>
  );
};

export default ReportContent;
